import { Box, Row, Text } from '~/commonComponents';
import { Icon } from '~/commonComponents/Icon';
import CloseIcon from '~/images/icons/CloseIcon';
import { Colors } from '~/themes/colors';

type TProfessionalType = 'favorite' | 'recent' | 'new';

interface IInvitedProfessionalPillProps {
  name: string;
  type: TProfessionalType;
  onRemove: () => void;
}

export const InvitedProfessionalPill = ({
  name,
  type,
  onRemove,
}: IInvitedProfessionalPillProps) => {
  const isFavorite = type === 'favorite';
  const borderColor = isFavorite ? Colors.favorites_400 : Colors.secondary_500;
  const backgroundColor = isFavorite ? Colors.favorites_50 : Colors.primary_50;

  return (
    <Row
      data-testid="invited-professional-pill"
      height={38}
      borderRadius={36}
      padding="0 16px"
      gap={10}
      alignItems="center"
      style={{
        border: `1.5px solid ${borderColor}`,
        backgroundColor,
        display: 'inline-flex',
        maxWidth: 'calc(90% - 4px)',
        overflow: 'hidden',
      }}
    >
      {isFavorite && (
        <Box marginRight={-4}>
          <Icon name="heart" size={20} color={Colors.favorites_400} />
        </Box>
      )}

      <Text
        fontSize={16}
        color="neutral_600"
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          minWidth: 0,
          flex: 1,
        }}
      >
        {name}
      </Text>

      <Row
        onClick={onRemove}
        data-testid="remove-professional"
        alignItems="center"
        style={{ cursor: 'pointer', flexShrink: 0 }}
      >
        <CloseIcon color={Colors.secondary_500} width={16} height={16} />
      </Row>
    </Row>
  );
};
